import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  size?: Unit;
  color?: Color;
  className?: string;
};

export const PlayerLoyalty = ({
  size = 1,
  color = 'currentColor',
  className,
}: Props) => {
  const pathId = useId();
  const fill = color || 'currentColor';

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: unitMapping[size] }}
      className={className}
    >
      <g clipPath={`url(#clip-${pathId})`}>
        <path d="M14.3551 15.6195C17.3928 15.6195 19.8554 13.1023 19.8554 9.99723C19.8554 6.89216 17.3928 4.375 14.3551 4.375C11.3173 4.375 8.85474 6.89216 8.85474 9.99723C8.85474 13.1023 11.3173 15.6195 14.3551 15.6195Z" />
        <path d="M5.23535 24.1647H23.476C22.6971 19.735 18.9124 16.375 14.3557 16.375C9.79894 16.375 6.01425 19.735 5.23535 24.1647Z" />
        <path d="M23.3528 24.9336H11.8409L10.1768 27.6272H25.7925L26.7669 24.9336H23.3563H23.3528ZM25.4802 27.2449H22.4092L23.2808 25.3159H26.1871L25.4768 27.2449H25.4802Z" />
        <path d="M24.961 8.82392H23.4135V10.7389H22.0135V8.82392H20.4797V7.53323H22.0135V5.73047H23.4135V7.53323H24.961V8.82392Z" />
      </g>
      <defs>
        <clipPath id={`clip-${pathId}`}>
          <rect
            width="21.5278"
            height="23.25"
            fill="white"
            transform="translate(5.23584 4.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
